import { useMemo } from 'react';
import { ChoiceDrill } from './ChoiceDrill';
import { makeFocusRound, STROOP_COLORS } from './focus';
import type { DrillProps } from './meta';

export function FocusDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makeFocusRound(level, seed), [level, seed]);
  return (
    <ChoiceDrill
      questions={questions} seed={seed} onDone={onDone} className="focus-drill" marks={false}
      choicesClass={(q) => (q.kind === 'count' ? 'nums' : 'colors')}
      info={(q) => (q.kind === 'count' ? { kind: q.kind, target: q.target } : { kind: q.kind, word: q.word })}
      render={(q) => (q.kind === 'count' ? (
        <div className="focus-q">
          <p className="lang-ask small-ask">'<b className="focus-target">{q.target}</b>' 의 개수는?</p>
          <div className="focus-grid" style={{ gridTemplateColumns: `repeat(${q.cols}, minmax(0, 1fr))` }} aria-label="기호 판">
            {q.grid.map((g, i) => <span key={i}>{g}</span>)}
          </div>
        </div>
      ) : (
        <div className="focus-q">
          <p className="lang-ask small-ask">글자의 <b>색</b>은? (뜻은 무시)</p>
          <div className="stroop-word" style={{ color: STROOP_COLORS[q.ink][1] }}>{q.word}</div>
        </div>
      ))}
      renderChoice={(q, i) => <span className="choice-text">{q.options[i]}</span>}
    />
  );
}
